export const API_NAME = "cardio";
export const ROUTE_NAME = "cardio";
export const COMPONENT_NAMES = ["cardio", "cardio"];
